require('./SuperBanner.scss');
const b = require('app/www/libs/b')('super-banner');

const _ = {
    get: require('lodash/get'),
};
const React = require('react');
const {connect} = require('react-redux');
const {
    openSuperBanner,
} = require('app/www/actions/superBanner');

const {withReq} = require('app/www/components/contexts/Req');
const {withExperiments} = require('app/www/components/contexts/Experiments');

const AdFox = require('app/www/components/blocks/AdFox/AdFox');
const AdvManager = require('app/www/components/blocks/AdvManager/AdvManager');
const Global = require('app/www/components/blocks/Global/Global');
const Ua = require('app/www/components/blocks/Ua/Ua');

const PageVisibilityAware = require('app/www/components/blocks/PageVisibilityAware/PageVisibilityAware');

const ADV_STAT_ID = 3;
const EXPERIMENT_MAIN_BANNER = 'main_banner';
const EXPERIMENT_MAIN_BANNER_CONTROL = 'default';
const EXPERIMENT_MAIN_BANNER_EXPEREMENT_MAX = 'experiment1';
const EXPERIMENT_MAIN_BANNER_EXPEREMENT_CMP = 'experiment2';

class SuperBanner extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            reload: false,
            isHidden: true,
            showDirectAdv: false,
        };

        this._onLoad = this._onLoad.bind(this);
        this._onError = this._onError.bind(this);
        this._onReload = this._onReload.bind(this);
        this._listenPageVisibility = this._listenPageVisibility.bind(this);
    }

    componentWillUnmount() {
        this._superBanner.removeEventListener('transitionend', this.props.dispatchOpenSuperBanner());
    }

    render() {
        const {
            req,
            experiments,
        } = this.props;

        const {
            isIndexUrl,
            isProgramUrl,
            isChannelUrl,
        } = req.lib('urlBuilder');

        let {
            isHidden,
        } = this.state;

        const AdFoxProps = Object.assign(Global.adFox.super_banner, {
            onLoad: this._onLoad,
            statId: ADV_STAT_ID,
        });

        const {hasBranding} = this.props;
        const isWrongPage = !isIndexUrl && !isProgramUrl && !isChannelUrl;

        const isExperiment = experiments.get(EXPERIMENT_MAIN_BANNER);
        const isNotMainAdaptivPage = !isIndexUrl && Ua.isTouchPhone;

        const AdvManagerProps = {
            blockId: Global.adv.super_banner,
            onLoad: this._onLoad,
            onError: this._onError,
            statId: ADV_STAT_ID,
        };

        if (isExperiment === EXPERIMENT_MAIN_BANNER_CONTROL && isIndexUrl) {
            AdvManagerProps.blockId = Global.adv.super_banner_exp_control;
        }

        if (isExperiment === EXPERIMENT_MAIN_BANNER_EXPEREMENT_MAX && isIndexUrl) {
            AdvManagerProps.blockId = Global.adv.super_banner_exp_max;
        }

        if (isExperiment === EXPERIMENT_MAIN_BANNER_EXPEREMENT_CMP && isIndexUrl) {
            AdvManagerProps.blockId = Global.adv.super_banner_exp_cmp;
        }

        if (isNotMainAdaptivPage || isWrongPage || hasBranding) {
            return null;
        }

        return (
            <div className={b({hidden: isHidden})} ref={ref => (this._superBanner = ref)}>
                {!Ua.isTouchPhone && <AdvManager {...AdvManagerProps} />}
                {Ua.isTouchPhone && <AdFox {...AdFoxProps} />}
                <PageVisibilityAware callback={this._listenPageVisibility}/>
            </div>
        );
    }

    /**
     * @private
     */
    _onLoad() {
        this.props.dispatchOpenSuperBanner();
    }

    /**
     * @private
     */
    _onError() {
        this.setState({
            isHidden: true,
            showDirectAdv: true,
        });
    }

    /**
     * @private
     */
    _onReload() {
        this.setState({
            reload: !this.state.reload,
        });
    }

    /**
     * Window in focus.
     * @param {Boolean} isHidden вкладка не активна
     * @private
     */
    _listenPageVisibility(isHidden) {
        if (!isHidden) {
            this._onReload();
        }
    }
}

function mapStateToProps(state) {
    return {
        hasBranding: _.get(state, 'channel.branding.status', false),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatchOpenSuperBanner: () => dispatch(openSuperBanner()),
    };
}

module.exports = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    withReq(withExperiments(
        SuperBanner
    ))
);
